import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setContractorPage } from '../redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useContractorSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getContractorSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website.contractor_page.contractor_section}`);
      console.log("🚀 ~ getContractorSectionJson ~ data:", response);
      console.log("🚀 ~ getContractorSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setContractorPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Contractor section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getContractorSectionJson();
  }, [getContractorSectionJson]);

  return {
    data,
    loading,
    error,
    getContractorSectionJson,
    fetchOnMount,
    refetch: getContractorSectionJson
  };
};

export default useContractorSection;
